import React from 'react'

const CapabilityCrossIcon = (
  <>
    <path
      d="M14 2L2 14"
      fill="none"
      stroke="#E01E4E"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 14L2 2"
      fill="none"
      stroke="#E01E4E"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export default CapabilityCrossIcon
